<template>
  <section>
    <div class="contests-container py-5 px-2" v-if="courses && courses.length">
      <v-expansion-panels>
        <v-expansion-panel v-for="(course, i) in courses" :key="i">
          <v-expansion-panel-header>
            {{ course.title }}
          </v-expansion-panel-header>

          <v-expansion-panel-content> </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <empty-state :imgWidth="500" v-else />
  </section>
</template>

<script>
import EmptyState from "../../../components/shared/EmptyState.vue";

export default {
  components: { EmptyState },
  props: ["courses"],
  data() {
    return {
      index: null,
    };
  },
  methods: {},
};
</script>

<style scoped>
.images-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.images-wrapper .image {
  width: 200px;
  height: 200px;
  background-size: cover;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 20px;
}
video {
  width: 100%;
  height: 400px;
}
</style>